
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/ski-accommodatie",
      function () {
        return require("private-next-pages/[region]/ski-accommodatie.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/ski-accommodatie"])
      });
    }
  